var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBluebarchart(_ref, svgRef) {
  var _ref2;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 71,
    viewBox: "0 0 72 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.757812,
    width: 70.7174,
    height: 70.7174,
    rx: 12.1927,
    fill: "#61CBDB",
    style: (_ref2 = {
      fill: "#61CBDB"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.3804 0.7961 0.8588)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1172 37.7324C22.1172 36.6974 22.9572 35.8574 23.9922 35.8574H27.7422C28.7772 35.8574 29.6172 36.6974 29.6172 37.7324V48.9824C29.6172 50.0174 28.7772 50.8574 27.7422 50.8574H23.9922C23.4949 50.8574 23.018 50.6599 22.6664 50.3082C22.3147 49.9566 22.1172 49.4797 22.1172 48.9824V37.7324ZM33.3672 30.2324C33.3672 29.1974 34.2072 28.3574 35.2422 28.3574H38.9922C40.0272 28.3574 40.8672 29.1974 40.8672 30.2324V48.9824C40.8672 50.0174 40.0272 50.8574 38.9922 50.8574H35.2422C34.7449 50.8574 34.268 50.6599 33.9164 50.3082C33.5647 49.9566 33.3672 49.4797 33.3672 48.9824V30.2324ZM44.6172 22.7324C44.6172 21.6974 45.4572 20.8574 46.4922 20.8574H50.2422C51.2772 20.8574 52.1172 21.6974 52.1172 22.7324V48.9824C52.1172 50.0174 51.2772 50.8574 50.2422 50.8574H46.4922C45.9949 50.8574 45.518 50.6599 45.1664 50.3082C44.8147 49.9566 44.6172 49.4797 44.6172 48.9824V22.7324Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluebarchart);
export default __webpack_public_path__ + "static/media/bluebarchart.228c2acf.svg";
export { ForwardRef as ReactComponent };